import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getSessionItem, updateSessionItem } from 'helpers/sessionStorage'
import { getStorageKey } from '.'
import { t } from 'helpers/i18n'

export default createSelectionListViewComponent({
  pageTitle: () => t('uom'),
  allowInfiniteLoader: () => false,
  allowSearch: () => false,
  getIdField: () => 'displayName',
  getValue: () => getSessionItem(getStorageKey(), {}).item?.unitOfMeasure || '',
  getOnChange: (self) => (each) =>
    updateSessionItem(getStorageKey(), {}, (draft) => {
      draft.item.unitOfMeasure = each.displayName
    }),
})()
